export default function Card({ children, className = '', padded = true }) {
  return (
    <div className={`rounded-2xl border border-gray-100 bg-white shadow-soft ${padded ? 'p-6' : ''} ${className}`}>
      {children}
    </div>
  );
}
